"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

const PostHogProvider = dynamic(
  () => import("@/app/providers").then((module) => module.PostHogProvider),
  { ssr: false }
);
const CartProvider = dynamic(
  () => import("@/lib/store/cart-context").then((module) => module.CartProvider),
  { ssr: false }
);
const CartBadgeWrapper = dynamic(
  () =>
    import("@/components/ui/cart-badge-wrapper").then(
      (module) => module.CartBadgeWrapper
    ),
  { ssr: false }
);
const Toaster = dynamic(
  () => import("@/components/ui/toaster").then((module) => module.Toaster),
  { ssr: false }
);

export default function AppClientShell({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isHome = pathname === "/";

  return (
    <PostHogProvider>
      {isHome ? (
        children
      ) : (
        <CartProvider>
          <CartBadgeWrapper />
          {children}
          <Toaster />
        </CartProvider>
      )}
    </PostHogProvider>
  );
}
